import Unauthorized from './Unauthorized';
import Forbidden from './Forbidden';
import NotFound from './NotFound';
import ServerError from './ServerError';

export { NotFound, Unauthorized, Forbidden, ServerError };

